export default __webpack_public_path__ + "static/media/arrow-right-circle.d4ca0a41.svg";